import ObtainGraphApiKey from "../../../../shared/obtain-graph-api-key.mdx";
import ProjectConfigPanel from 'gatsby-theme-apollo-docs/shared/project-config-panel.mdx';
import RegisterFederatedCli from "../../../../shared/register-federated-cli.mdx";
import * as React from 'react';
export default {
  ObtainGraphApiKey,
  ProjectConfigPanel,
  RegisterFederatedCli,
  React
};